import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ItineraryCancellation from '../components/itinerary/ItineraryCancellation';

const Policy = () => (
  <>
    <Header />
    <main style={{ minHeight: '60vh', padding: '2rem 0', marginTop: '80px' }}>
      <div className="container">
        <ItineraryCancellation />
      </div>
    </main>
    <Footer />
  </>
);

export default Policy;
